<template>
  <v-row justify="center" style="z-index: 9999">
    <v-dialog
      @keydown.esc="closeModal()"
      max-width="600px"
      v-model="isVisible"
      v-on:click:outside="closeModal"
      overlay-opacity="1"
      transition="slide-y-transition"
    >
      <v-card>
        <v-toolbar
          class="black--text d-flex justify-center"
          color="#fbc501"
          tile
        >
          <v-toolbar-title v-if="!isEdit">Dodaj kategorię</v-toolbar-title>
          <v-toolbar-title v-else>Edytuj kategorię</v-toolbar-title>
        </v-toolbar>
        <BlackButton
          fab
          small
          icon="times"
          iconMargin=""
          class="close"
          @click.native="closeModal()"
        />
        <ValidationObserver ref="obs" v-slot="{ invalid }" mode="eager">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-checkbox
                    color="#fbc501"
                    v-model="visible"
                    label="Widoczny"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="12">
                  <VTextFieldWithValidation
                    rules="required"
                    v-model="name"
                    label="Nazwa"
                    color="indigo"
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="12" sm="12">
                  <v-file-input
                    ref="fileupload"
                    v-model="photo"
                    dense
                    outlined
                    rounded
                    label="Załącz zdjęcie"
                    :key="inputKey"
                    accept="image/png,image/jpeg"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="warning" text v-on:click="closeModal">
              <font-awesome-icon icon="times" class="mr-1" />
              Anuluj
            </v-btn>
            <v-btn
              v-if="!isEdit"
              color="success"
              text
              :disabled="invalid"
              v-on:click="addCategory()"
            >
              <font-awesome-icon icon="check" class="mr-1" />
              Dodaj kategorię
            </v-btn>
            <v-btn
              v-else
              color="success"
              text
              :disabled="invalid"
              v-on:click="editCategory()"
            >
              <font-awesome-icon icon="check" class="mr-1" />
              Zapisz kategorię
            </v-btn>
          </v-card-actions>
        </ValidationObserver>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import VTextFieldWithValidation from "../inputs/VTextFieldWithValidation";

import BlackButton from "../buttons/BlackButton";
import shared from "../../shared";

export default {
  name: "CategoryModal",
  props: ["isVisible", "isEdit"],

  components: {
    ValidationObserver,
    BlackButton,
    VTextFieldWithValidation,
  },
  created() {},

  data: () => ({
    name: "",
    photo: null,
    inputKey: 0,
    visible: true,
  }),
  computed: {
    category() {
      return this.$store.getters["catalogue/getCategory"];
    },
  },
  watch: {
    category: function () {
      this.name = this.category.name;
      this.visible = this.category.visible;
    },
  },
  methods: {
    formatRole(role) {
      return shared.formatRole(role);
    },
    closeModal() {
      this.name = "";
      this.visible = true;
      this.photo = null;
      this.inputKey++;
      this.$refs.obs.reset();
      this.$emit("closeModal");
    },
    async addCategory() {
      let formData = new FormData();
      if (this.photo) {
        formData.append("file", this.photo);
      }
      formData.append("name", this.name);
      formData.append("visible", true);
      await this.$store.dispatch("catalogue/addCategory", formData);
      this.closeModal();
    },
    async editCategory() {
      let formData = new FormData();
      if (this.photo) {
        formData.append("file", this.photo);
      }
      formData.append("name", this.name);
      formData.append("visible", this.visible);

      let object = {
        id: this.category.id,
        formData: formData,
      };

      if (!this.visible) {
        const isCategoryEmpty = await this.$store.dispatch(
          "catalogue/checkCategoryDoesNotHaveProducts",
          this.category.id
        );
        if (!isCategoryEmpty) {
          this.$store.dispatch(
            "snackbar/setSnackbar",
            {
              color: "red",
              icon: "exclamation-triangle",
              message: "Nie można ukryć kategorii, która zawiera produkty!",
            },
            { root: true }
          );
          this.$store.dispatch("snackbar/toggleSnackbar", true, { root: true });
          return;
        }
      }

      await this.$store.dispatch("catalogue/editCategory", object);
      this.closeModal();
    },
  },
};
</script>
<style lang="scss" scoped>
.outlined-form-section {
  position: relative;

  border-color: rgba(0, 0, 0, 0.38);
  border-width: 2px;
}

.outlined-form-section-title {
  top: -15px;
  left: 10px;
  position: absolute;

  padding: 0.2rem 0.5rem;

  background-color: white;

  font-size: 12px;
}
.close {
  position: absolute;
  top: 1%;
  right: 3%;
  z-index: 10000000;
}
// .v-overlay__scrim {
//   backdrop-filter: blur(5px) !important;
//   background-color: transparent !important;
// }
</style>
